module.exports = __webpack_public_path__ + "static/media/favicon.ccb3395e.ico";